export default "__VITE_ASSET__40c03369__"